import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { sumArr, sumArrByKey } from "./utils/dictionaries";

/*
const arrNum = Array.from(Array(10000000)).map((e, i) => 2);
const sum = (acc: number, n: number): number => acc + n;


console.time("SUM REDUCE");
const resReduce = arrNum.reduce(sum, 0);
console.timeEnd("SUM REDUCE");

console.time("SUM LOOP");
const resLoop = (() => {
  let count = 0;
  for (let j = 0; j < arrNum.length; ++j) {
    count += arrNum[j];
  }
  return count;
})();
console.timeEnd("SUM LOOP");

const arrObjNum = arrNum.map((n) => ({ value: n }));
console.time("SUM LOOP OVER KEY");
const resLoopKey = (() => {
  let count = 0;
  for (let j = 0; j < arrObjNum.length; ++j) {
    count += arrObjNum[j].value;
  }
  return count;
})();
console.timeEnd("SUM LOOP OVER KEY");

console.time("SUM LOOP OVER KEY ALT");
const resLoopKeyAlt = (() => {
  const newArr = arrObjNum.map((e) => e.value);
  let count = 0;
  for (let j = 0; j < newArr.length; ++j) {
    count += newArr[j];
  }
  return count;
})();
console.timeEnd("SUM LOOP OVER KEY ALT");

console.time("SUM TEST");
const sumTest = sumArr(arrNum);
console.timeEnd("SUM TEST");

console.log("res sum", resReduce, resLoop, resLoopKey, resLoopKeyAlt, sumTest);
*/
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
